import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectFlowsOnSiteEnabled } from '../../../flow/selectors/FlowSelectors';
import { ExploreContentApi_ContentType } from '../../../ts/ServerApi/types/IContent';
import { contentCountsRequest } from '../../actions/spaces/ContentCountsActions';
import { selectContentCounts } from '../../selectors/ContentCountsSelector';
import { selectCurrentlyApplicableContentTypes, selectHiddenContentTypeForCurrentSpace } from '../../selectors/ContentFilterSelectors';
import { AppState } from '../../state/AppState';
import { SpaceInfoTypeContentCount } from '../../state/ContentCountsState';
import { isFavoritesSpace, isProjectSpace, isSharedWithMeSpace, isSiteUserContentSubspace, isPersonalSpace, isSingleCollectionSpace } from '../../state/SpaceInfo';
import { MapDispatchToProps, MapStateToProps } from '../../utils/ConnectUtils';
import { FilterByTypePanel, FilterByTypePanelDispatchProps, FilterByTypePanelOwnProps, FilterByTypePanelStateProps } from './FilterByTypePanel';

const getCounts = (state: AppState): SpaceInfoTypeContentCount<ExploreContentApi_ContentType> => {
  if(isFavoritesSpace(state.spaceInfo)){
    return selectContentCounts<'favorites'>(state, 'favorites');
  } else if(isProjectSpace(state.spaceInfo)){
    return selectContentCounts<'project'>(state, 'project');
  } else if(isSiteUserContentSubspace(state.spaceInfo)){
    return selectContentCounts<'siteuser'>(state, 'siteuser');
  } else if(isSharedWithMeSpace(state.spaceInfo)) {
    return selectContentCounts<'sharedWithMe'>(state, 'sharedWithMe');
  } else if(isPersonalSpace(state.spaceInfo)) {
    return selectContentCounts<'personal'>(state, 'personal');
  } else if (isSingleCollectionSpace(state.spaceInfo)) {
    return selectContentCounts<'collection'>(state, 'collection');
  }
};

export const mapStateToSpaceProps: MapStateToProps<FilterByTypePanelStateProps> =
  (state: AppState) => ({
    contentCounts: getCounts(state),
    contentFilter: selectCurrentlyApplicableContentTypes(state),
    showWorkbooksAsViews: state.contentExplorer.showWorkbooksAsViews,
    flowsEnabled: selectFlowsOnSiteEnabled(state),
    hiddenContentTypes: selectHiddenContentTypeForCurrentSpace(state)
  });

export const mapDispatchToProps: MapDispatchToProps<FilterByTypePanelDispatchProps> =
  (dispatch) => bindActionCreators({
    onComponentDidUpdate: contentCountsRequest
  },
  dispatch);

export const ConnectedFilterByTypePanel: React.ComponentClass<FilterByTypePanelOwnProps> =
  connect(mapStateToSpaceProps, mapDispatchToProps)(FilterByTypePanel);
